import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {DigitalInspectionApiService, DigitalInspectionReportResult} from '@app/services/api/digital-inspection-api.service';

@Injectable({providedIn: 'root'})
export class PublicDamageInspectionResolver {
  constructor(private digitalInspectionApi: DigitalInspectionApiService) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<DigitalInspectionReportResult> {
    return this.digitalInspectionApi.getPublicReport(route.paramMap.get('vehicleUuid'))
      .pipe(
        catchError(() => of<DigitalInspectionReportResult>({
          available: false,
          reason: 'No damage inspection report available for this vehicle.',
        }))
      );
  }
}
